'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findMatchingTemplate(charge, templates) {
    return _lodash2.default.first(_lodash2.default.compact(_lodash2.default.map(templates, function (template, templateId) {
        var result = matchTemplate(charge, template);
        return result.success ? { type: templateId, params: result.params } : null;
    })));
}

function matchTemplate(charge, template) {

    if ((typeof charge === 'undefined' ? 'undefined' : (0, _typeof3.default)(charge)) !== (typeof template === 'undefined' ? 'undefined' : (0, _typeof3.default)(template))) return { success: false, params: {} };

    var params = {};
    var success = true;

    _lodash2.default.each(template, function (v, k) {

        if (_lodash2.default.isString(v) && v.indexOf('%{') === 0) {
            params[v.slice(2, -1)] = charge[k];
        } else if (_lodash2.default.isArray(v) || _lodash2.default.isObject(v)) {
            var ret = matchTemplate(charge[k], v);
            success = success && ret.success;
            params = (0, _extends3.default)({}, params, ret.params);
        } else {
            success = success && charge[k] === v;
        }
    });

    return { params: params, success: success };
}

function fillTemplate(_ref) {
    var template = _ref.template,
        params = _ref.params;


    var parse = function parse(v) {
        if (_lodash2.default.isString(v) && v.indexOf('%{') === 0) {
            return params[v.slice(2, -1)];
        } else if (_lodash2.default.isArray(v) || _lodash2.default.isObject(v)) {
            return fillTemplate({ template: v, params: params });
        } else {
            return v;
        }
    };

    if (_lodash2.default.isArray(template)) {
        return _lodash2.default.map(template, parse);
    } else {
        var ret = {};
        _lodash2.default.each(template, function (v, k) {
            ret[k] = parse(v);
        });
        return ret;
    }
}

exports.default = {
    fillTemplate: fillTemplate,
    matchTemplate: matchTemplate,
    findMatchingTemplate: findMatchingTemplate
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/JsonTemplates.js
// module id = 464
// module chunks = 0